/* eslint-disable react/function-component-definition */
import React from 'react'
import { Select } from 'antd'

interface SelectTextoProps {
  opcoes: string[]
  value: string[]
  handle: (valores: string[]) => void
  placeholder?: string
  width?: boolean
  carregando?: boolean
  /** Texto quando nao ha nenhuma opcao. Sem isto, "ainda carregando" e "o tenant nao tem nenhuma" ficam iguais. */
  vazio?: string
  /**
   * Como exibir cada opcao. O VALOR enviado a API continua sendo a string original — isto e so
   * apresentacao, derivada do proprio valor por uma funcao pura, entao rotulo e valor nunca podem
   * divergir (diferente do SelectCompanie, que casa nome com id por busca e pode nao achar).
   */
  rotulo?: (valor: string) => string
}

/**
 * Select multiplo para filtros cujo valor JA E o texto enviado a API (Segmento do cliente,
 * Categoria de material).
 *
 * Existe separado do SelectCompanie porque este nao precisa da conversao nome -> id: o rotulo e o
 * valor sao a mesma coisa. Isso elimina, para estes filtros, a colisao de homonimos do outro select
 * (o find pelo nome pega o primeiro). Tambem nao depende do useSales para saber se esta carregando,
 * o que o deixa util fora das telas que carregam aqueles catalogos.
 */
const SelectTexto: React.FC<SelectTextoProps> = ({
  opcoes,
  value,
  handle,
  placeholder,
  width,
  carregando,
  vazio,
  rotulo,
}) => (
  <Select
    mode="multiple"
    placeholder={placeholder || 'Pesquise uma palavra chave'}
    value={value}
    onChange={handle}
    loading={carregando}
    notFoundContent={
      carregando ? 'Carregando...' : vazio || 'Nenhuma opção disponível'
    }
    style={width ? { width: '100%' } : { width: '70%' }}
    // Casa por texto digitado; as opcoes sao rotulos, nao ids. Busca no rotulo E no valor cru, para
    // que digitar so os digitos do NCM ache a opcao mesmo com o prefixo no rotulo.
    filterOption={(entrada, opcao) => {
      const busca = entrada.toUpperCase()
      const valor = String(opcao?.value ?? '')
      return (
        valor.toUpperCase().includes(busca) ||
        String(opcao?.label ?? '')
          .toUpperCase()
          .includes(busca)
      )
    }}
    options={opcoes.map(item => ({
      value: item,
      label: rotulo ? rotulo(item) : item,
    }))}
  />
)

export default SelectTexto
